import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// Dynamically load the Google Maps API script
const script = document.createElement('script');
script.src = `${environment.googleMapsApiUrl}?libraries=places`;
script.async = true;
script.defer = true;
document.head.appendChild(script);

// Bootstrap the Angular app after the script loads successfully
script.onload = () => {
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error('Bootstrap error:', err));
};

script.onerror = (error) => {
  console.error('Failed to load Google Maps API:', error);
};
